import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { CheckItem } from './CheckItem';
export function HeroSection() {
  return <section className="relative min-h-screen w-full bg-navy-darkest overflow-hidden" data-id="element-102">
      <div className="absolute inset-0 opacity-40" style={{
      background: 'radial-gradient(ellipse at 70% 30%, rgba(26, 39, 68, 0.8) 0%, transparent 60%)'
    }} data-id="element-103" />

      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16" data-id="element-104">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="text-center" data-id="element-105">
          <h1 className="font-playfair text-4xl md:text-5xl lg:text-6xl font-bold text-cream leading-tight mb-4" data-id="element-106">
            Si te despiertas entre las 2:00 y 3:00 AM
            <br data-id="element-107" />
            <span className="text-amber" data-id="element-108">con la mente acelerada…</span>
          </h1>

          <p className="font-playfair text-2xl md:text-3xl italic text-amber mb-6" data-id="element-109">
            Esto NO es insomnio.
          </p>

          <p className="text-xl md:text-2xl text-cream font-light mb-8 max-w-2xl mx-auto" data-id="element-110">
            Tu cuerpo está en estado de alerta… y mientras no entiendas esto,
            seguirás repitiendo el mismo patrón cada noche.
          </p>

          <div className="space-y-4 mb-10 max-w-2xl mx-auto text-lg text-cream-muted leading-relaxed" data-id="element-111">
            <p className="text-cream font-medium" data-id="element-112">
              No es que no puedas dormir… es que tu cuerpo no sabe cómo
              apagarse.
            </p>
            <p data-id="element-113">Te acuestas cansada… pero algo dentro de ti sigue activo.</p>
            <p data-id="element-114">Y cuando despiertas… ya no puedes volver a desconectar.</p>
          </div>

          <div className="flex flex-col items-center mb-10" data-id="element-115">
            <CTAButton className="w-full sm:w-auto" data-id="element-116">
              QUIERO DORMIR SIN DESPERTARME
            </CTAButton>
          </div>

          {/* Woman 2:37 AM image (swapped from identification) */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.4
        }} className="mt-10 flex justify-center" data-id="element-117">
            <div className="relative w-full max-w-lg overflow-hidden rounded-xl" data-id="element-118">
              <img src="https://cdn.magicpatterns.com/uploads/vnqZ2DZqaNbPKbSij5pgA5/hf_20260218_162154_fa115925-ac61-4ad3-9326-e0983f147151.png" alt="Mujer despierta a las 2:37 AM" className="w-full h-auto object-cover rounded-xl" data-id="element-119" />
              <div className="absolute inset-0 rounded-xl" style={{
              boxShadow: 'inset 0 0 60px rgba(10, 14, 26, 0.5)'
            }} data-id="element-120" />
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}